import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent {

  @Input()
  public placeholder: string = '';
  @Output()
  public changeValue: EventEmitter<{ value: string }> = new EventEmitter();

  public filterForm: FormGroup = null;

  private filterControl: FormControl = null;

  constructor(
    private formBuilder: FormBuilder
  ) {
    this.createForm();
  }

  public emitData(): void {
    this.changeValue.emit({ value: this.filterControl.value });
  }

  public buttonVisibility(): boolean {
    return this.filterControl.value;
  }

  public clearInputField(): void {
    this.filterControl.setValue('');
    this.changeValue.emit({ value: '' });
  }

  private createForm(): void {
    this.filterForm = this.formBuilder.group({
      filter: ''
    });

    this.filterControl = this.filterForm.get('filter') as FormControl;
  }
}



// WEBPACK FOOTER //
// /dist/src/app/shared/filter/filter.component.ts